import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import InputMask from "react-input-mask";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";
import Util from "../../../actions/util.js";
import DataUtil from "../../../actions/data.js";

import ConsultaReuniaoResultado from "./ConsultaReuniaoResultado";

class ConsultaReuniao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        periodoDe: DataUtil.primeiroDiaMes(),
        periodoAte: DataUtil.hoje(),
        profissionalId: this.props.usuario.perfil < 2 ? 0 : this.props.usuario.id,
        topico: "",
        tipo: 0,
        numeroAta: 0
      },
      usuarios: [],
      resultado: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.excluir = this.excluir.bind(this);
    this.duplicar = this.duplicar.bind(this);
  }

  componentWillMount() {
    UI.loader("show", "Aguarde, buscando profissionais...");
    API.get("/usuarios/ativos").then(
      (json) => {
        // Cria uma lista simplificada de usuários
        let usuarios = [{ id: 0, nome: "TODOS" }];
        json.data.forEach(usuario => {
          usuarios.push({
            id: usuario.id,
            nome: usuario.nome
          });
        });
        this.setState({ usuarios: usuarios });
        UI.loader("hide");
      });
  }

  handleSubmit(event) {
    event.preventDefault();

    let data = this.state.consulta;
    if (!DataUtil.validarData(data.periodoDe)) {
      data.periodoDe = DataUtil.primeiroDiaMes();
    }
    if (!DataUtil.validarData(data.periodoAte)) {
      data.periodoAte = DataUtil.hoje();
    }

    UI.loader("show", "Um momento...");
    API.post("/reunioes/consulta", data)
      .then(
        function (json) {
          let retorno = json.data.filter((reuniao) => {
            if (parseInt(this.state.consulta.tipo) === 1 && parseInt(this.state.consulta.numeroAta) === 0 && !reuniao.procedimento.ataReuniao) return false;
            if (parseInt(this.state.consulta.tipo) === 1 && parseInt(this.state.consulta.numeroAta) !== 0 && reuniao.id !== parseInt(this.state.consulta.numeroAta)) return false;
            return true;
          });

          this.setState({ resultado: retorno });
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  handleChange(event) {
    let consulta = this.state.consulta;
    consulta[event.target.name] = event.target.value;

    if (parseInt(consulta.tipo) === 0) {
      consulta.numeroAta = 0;
    }

    this.setState({ consulta: consulta });
  }

  exportarCSV() {
    if (!Util.exportarReunioesCSV(this.state.resultado)) {
      UI.alert(false, "Não há nenhum resultado para ser exportado.");
    }
  }

  excluir(reuniao, index) {
    UI.confirm("Atenção", "Tem certeza que deseja excluir atividade / reunião #" + reuniao.id + "?").then((confirma) => {
      if (confirma) {
        UI.loader("show", "Um momento...");
        API.delete("/reunioes/" + reuniao.id)
          .then(
            (json) => {
              UI.alert(json.success, json.message);
              let resultado = this.state.resultado.filter((value, i, arr) => { return i !== index; });
              this.setState({ resultado: resultado });
              UI.loader("hide");
            }
          )
          .catch(
            (json) => {
              UI.alert(false, json.message);
              UI.loader("hide");
            });
      }
    });
  }

  duplicar(reuniao, index) {
    UI.confirm("Atenção", "Tem certeza que deseja duplicar a reunião #" + reuniao.id + "?").then((confirma) => {
      if (confirma) {
      UI.loader("show", "Um momento...");
      API.post("/reunioes/" + reuniao.id + "/duplicar")
      .then((json) => {
          UI.alert(json.success, json.message);
          if (json.success) {
            this.state.resultado.splice(index, 0, json.data);
            let resultado = this.state.resultado;
            this.setState({ resultado: resultado });
          }
          UI.loader("hide");
        }
      )
      .catch((json) => {
          UI.alert(false, json.message);
          UI.loader("hide");
        });
      }
    });
  }

  render() {
    let filtrarAta = parseInt(this.state.consulta.tipo) === 1;

    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">CONSULTA ATIVIDADE / REUNIÃO</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => { this.props.history.push("/reuniao/cadastro"); }}
                      className="btn btn-rounded btn-icons btn-outline-success"
                      type="button">
                      <i className="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <p className="card-description" />
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group row">
                      <div className="col-md-3">
                        <label>Período De</label>
                        <InputMask
                          placeholder="PERÍODO DE"
                          name="periodoDe"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoDe}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Período Até</label>
                        <InputMask
                          placeholder="PERIODO ATÉ"
                          name="periodoAte"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoAte}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-3">
                        <label>Profissional</label>
                        <select
                          name="profissionalId"
                          className="form-control"
                          value={this.state.consulta.profissionalId}
                          onChange={this.handleChange}
                        >
                          {this.state.usuarios.map(
                            (usuario, i) => {
                              if (this.props.usuario.perfil < 2 || this.props.usuario.id === usuario.id)
                                return (
                                  <option key={usuario.id} value={usuario.id}>
                                    {usuario.nome}
                                  </option>
                                );
                              return false;
                            }
                          )}
                        </select>
                      </div>
                      <div className="col-sm-3">
                        <label>Tópico</label>
                        <input
                          placeholder="TÓPICO"
                          name="topico"
                          type="text"
                          className="form-control"
                          value={this.state.consulta.topico}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <label>Tipo</label>
                        <select
                          name="tipo"
                          className="form-control"
                          value={this.state.consulta.tipo}
                          onChange={this.handleChange}
                        >
                          <option value={0}>TUDO</option>
                          <option value={1}>APENAS COM ATA</option>
                        </select>
                      </div>
                      {filtrarAta &&
                      <div className="col-sm-1">
                        <label>Nº ATA</label>
                        <input
                          placeholder="0"
                          name="numeroAta"
                          type="number"
                          className="form-control"
                          value={this.state.consulta.numeroAta}
                          onChange={this.handleChange}
                        />
                      </div>}
                    </div>
                    <div className="row">
                      <div className="col-sm-12 text-right">
                        <button
                          type="button"
                          className="btn btn-sm btn-success mb-2"
                          onClick={() => this.exportarCSV()}
                        >
                          <i className="fa fa-download"></i>&nbsp;
                            Exportar CSV
                        </button>
                        &nbsp;
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-2"
                        >
                          <i className="fa fa-search"></i>&nbsp;
                          Pesquisar
                        </button>
                      </div>
                    </div>
                    <ConsultaReuniaoResultado habilitarPagamento={false} resultado={this.state.resultado} onExcluir={this.excluir} onDuplicar={this.duplicar} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </form >
    );
  }
}

export default withRouter(ConsultaReuniao);